var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.602,
    height: 32.481,
    viewBox: "0 0 40.602 32.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-mail-outline",
    "data-name": "Icon material-mail-outline",
    d: "M39.542,6H7.06a4.055,4.055,0,0,0-4.04,4.06L3,34.421a4.072,4.072,0,0,0,4.06,4.06H39.542a4.072,4.072,0,0,0,4.06-4.06V10.06A4.072,4.072,0,0,0,39.542,6Zm0,28.421H7.06V14.12L23.3,24.271,39.542,14.12ZM23.3,20.211,7.06,10.06H39.542Z",
    transform: "translate(-3 -6)",
    fill: "#ed8e88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailRed);
export default __webpack_public_path__ + "static/media/mail-red.068d95e4be73d7e49adb2117e1b63821.svg";
export { ForwardRef as ReactComponent };